export default {
    id: "hotline-8800-2026",
    articleType: "release",
    slug: "edinyy-nomer-8-800",
    date: "30 марта 2026",
    dateTime: "2026-03-30",
    modifiedTime: "2026-03-30",
    author: "Редакция «Светофор Логистика»",
    category: "Сервис · 2026",
    contentType: "Сервис",
    title: "У «Светофор Логистика» появился единый номер 8-800",
    sidebarTitle: "Единый бесплатный номер 8-800",
    seoTitle:
        "Единый номер 8-800 «Светофор Логистика»: клиентская поддержка",
    seoDescription:
        "«Светофор Логистика» запустила колл-центр и единый бесплатный номер 8 (800) 222-70-79 для вопросов по работе платформы и клиентской поддержке.",
    image: "/img/news/edinyy-nomer-8-800/cover.webp",
    imageAlt:
        "Единый номер колл-центра «Светофор Логистика» 8 (800) 222-70-79",
    content: {
        subtitle:
            "Запустили колл-центр для оперативной клиентской поддержки",
        lead: [
            "У «Светофор Логистика» появился единый бесплатный номер 8 (800) 222-70-79. Теперь получить помощь по работе платформы можно ещё быстрее.",
        ],
        sections: [
            {
                icon: "☎️",
                title: "Как связаться",
                items: [
                    {
                        title: "8 (800) 222-70-79",
                        text: "Звонок по России бесплатный.",
                    },
                    {
                        title: "С 04:00 до 18:00 по Москве",
                        text: "Расширенный график помогает оставаться на связи и с восточными регионами, и с центральной частью России.",
                    },
                ],
            },
            {
                icon: "💬",
                title: "С какими вопросами можно звонить",
                paragraphs: [
                    "Операторы помогут с вопросами клиентской поддержки: подскажут по работе платформы, личному кабинету и статусу заявки.",
                ],
            },
            {
                icon: "⚙️",
                title: "Технические вопросы",
                paragraphs: [
                    "Если вопрос требует участия разработчиков и детального изучения технических данных, напишите в службу поддержки по адресу support@svetofore.ru.",
                ],
            },
        ],
        action: {
            href: "mailto:support@svetofore.ru",
            label: "Написать в техническую поддержку",
        },
    },
};
